import React, { memo, useEffect, useMemo, useCallback } from 'react';
import {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';
import { BonanzaCoinLoaderProps } from './BonanzaCoinLoader.types';

function BonanzaCoinLoader({
  width = 80,
  height = 80,
  justifyContent = 'center',
  ...rest
}: BonanzaCoinLoaderProps) {
  const rotation = useSharedValue(0);

  const startAnimation = useCallback(() => {
    rotation.value = 0;

    const animationConfig = {
      duration: 900,
      easing: Easing.linear,
    };

    rotation.value = withRepeat(withTiming(360, animationConfig), -1, false);
  }, []);

  useEffect(() => {
    startAnimation();
  }, [startAnimation]);

  const animatedStyles = useAnimatedStyle(
    () => ({
      transform: [{ rotateY: `${rotation.value}deg` }],
    }),
    [],
  );

  const iconProps = useMemo(
    () => ({
      name: 'bonanzaCoin' as const,
      gradient: 'accentBackground' as const,
      width,
      height,
    }),
    [width, height],
  );

  return (
    <Box
      width="100%"
      height="100%"
      alignItems="center"
      animatedStyle={animatedStyles}
      justifyContent={justifyContent}
      {...rest}
    >
      <Icon {...iconProps} />
    </Box>
  );
}

export default memo(BonanzaCoinLoader);
